<template>
  <div class="successful-case-bom">
    <div class="bom-header">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增一行</el-button>
    </div>
    <div class="bom-body">
      <el-form ref="BomFormRef" :model="_data" :show-message="false" size="small">
        <el-table class="form-table" :data="dataList" border>
          <el-table-column label="#" type="index" width="50" align="center" />
          <el-table-column label="客户名称" class-name="is-input">
            <template #default="{ row, $index }">
              <el-form-item :prop="`dataList.${$index}.customerName`" :rules="required">
                <el-input v-model="row.customerName" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="项目名称" class-name="is-input">
            <template #default="{ row, $index }">
              <el-form-item :prop="`dataList.${$index}.projectName`" :rules="required">
                <el-input v-model="row.projectName" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="方案类型" class-name="is-input" v-if="type === 'PROGRAMME'">
            <template #default="{ row, $index }">
              <el-form-item :prop="`dataList.${$index}.programmeType`" :rules="required">
                <el-select v-model="row.programmeType" placeholder="请选择">
                  <el-option v-for="item in options.CustomerCategory" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="交付内容" class-name="is-input">
            <template #default="{ row, $index }">
              <el-form-item :prop="`dataList.${$index}.deliveryScope`" :rules="required">
                <el-input v-model="row.deliveryScope" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="证明材料" width="200">
            <template #default="{ row }">
              <el-link type="primary" :href="row.materialUrl" target="_blank" v-if="row.materialUrl">{{ row.materialUrl | urlName }}</el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template #default="{ row, $index }">
              <div style="display: flex;justify-content: center;">
                <el-upload
                  :action="uploadUrl"
                  :show-file-list="false"
                  :before-upload="fileBeforeUpload"
                  :on-success="res => fileUploadSuccess(row, res)"
                  :file-list="row.fileList"
                  :limit="1"
                >
                  <el-button type="text" stopCountDown>上传材料</el-button>
                </el-upload>
                <el-button style="margin-left: 10px;" type="text" stopCountDown @click="handleDelete($index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </div>
  </div>
</template>

<script>
import DictionaryApi from '@/api/setting/dictionaryApi.js';

export default {
  filters: {
    urlName: (val) => val ? val.slice(-20) : ''
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_URL + 'longstron/base/doc/file/upload',
      dataList: [],
      required: [{ required: true }],
      options: {
        CustomerCategory: [] // 方案类型
      }
    };
  },
  created() {
    this.getDataDictionary();
  },
  methods: {
    handleAdd() {
      this.dataList.push({
        customerName: '',
        projectName: '',
        programmeType: '',
        deliveryScope: '',
        materialUrl: '',
        fileList: []
      });
    },
    handleDelete(index) {
      this.dataList.splice(index, 1);
    },
		fileBeforeUpload(file) {
			let isLt5M = file.size / 1024 / 1024 < 5;
			if (!isLt5M) {
				this.$message.warning('上传文件大小不能超过 5MB!');
        return;
			}
			return true;
		},
		fileUploadSuccess(row, res) {
			this.$message.success('上传成功！');
			row.materialUrl = res.model.httpFilePath;
      row.fileList = [];
		},
    setStoreRows(list) {
      this.dataList = list;
    },
    /**
		 * @description 获取字典行业类别(方案类型)
		 */
		getDataDictionary() {
			DictionaryApi.getByDictKey("CustomerCategory").then(res => {
				if (res != null && res.code === '00000') {
					this.options.CustomerCategory = res.rows;
				}
			});
		},
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.BomFormRef.validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    getStoreRows() {
      return this.dataList;
    }
  }
};
</script>

<style lang="less" scoped>
.bom-header {
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-end;
}

.bom-body {
  :deep(.el-table) {
    .el-table__fixed-header-wrapper .cell,
    .el-table__header-wrapper .cell {
      font-family: @font-medium;
      color: @default-color;
    }
    th.el-table__cell.table-required>div::before {
      content: '*';
      color: red;
      margin-right: 2px;
    }
    .el-table__cell {
      padding: 6px 0;
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
